import React from 'react';
import PropTypes from 'prop-types';

import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Header, {headerItemsLabels} from '../../../../Common/Header/header';
import ShelfLifeUpdateViewGrid from './ShelfLifeUpdateViewGrid/shelfLifeUpdateViewGrid';
import CreateReasonTypeDialog from './Dialogs/CreateReasonTypeDialog/createReasonTypeDialog';
import {MatSettingsMenuItemsIds} from '../../../../../enums/navigationMenuItemsIds';
import {dialogsNames} from '../../../../../enums/dialogsNames';
import CommonDialogWrapper from '../../../../Dialogs/CommonDialogWrapper/commonDialogWrapper';

export default class ShelfLifeUpdateView extends React.PureComponent {

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.reasons.shelflife.view.');
  }

  componentDidMount() {
    this.props.actions.init(false);
    this.props.actions.matSettingsPageActions.onSelectedMenuItemChanged(MatSettingsMenuItemsIds.NAV_ELEMENT_REASONS_SHELF_LIFE_UPDATE);
  }

  getHeaderItems() {
    let {actions} = this.props;
    let hasRows = this.props.sHasRows;
    let selectedRowsData = this.props.sSelectedRowsData;

    return {

      buttons: [
        {
          id:'create',
          label: headerItemsLabels.CREATE,
          icon: 'pl pl-icon-add',
          action: actions.header.onShowCreateReasonTypeDialog,
          actionData: {
            activeDialog: dialogsNames.CREATE_REASON_TYPE_DIALOG,
          }
        },
        {
          id:'edit',
          label: headerItemsLabels.EDIT,
          icon: 'pl pl-edit-icon',
          disabled: !(hasRows && selectedRowsData.size === 1),
          action: actions.header.onShowCreateReasonTypeDialog,
          actionData: {
            activeDialog: dialogsNames.CREATE_REASON_TYPE_DIALOG,
            itemToEdit : selectedRowsData?.get(0)
          }
        }
      ],

      kebab: {
        disabled: !selectedRowsData || selectedRowsData.size === 0,
        menuItems: [
          {
            id:'remove',
            label: headerItemsLabels.DELETE,
            action: actions.header.onRemoveReasonClick,
            disabled: (!selectedRowsData || selectedRowsData.size === 0),
            actionData: selectedRowsData
          }
        ]
      }
    };
  }

  reloadPage = () => {
    this.props.actions.init(true);
  };

  render() {
    let title = this.labels.get('title');
    let headerItems = this.getHeaderItems();
    return (
      <div className="administration-view">
        <div className="title">{title}</div>

        <Header {...headerItems}/>

        <ShelfLifeUpdateViewGrid actions={this.props.actions.shelfLifeUpdateViewGridActions} />

        <CommonDialogWrapper dialogComponent={CreateReasonTypeDialog}
                             dialogName={dialogsNames.CREATE_REASON_TYPE_DIALOG}
                             actions={this.props.actions.createReasonTypeDialogActions}
                             reloadParentComponent={this.reloadPage}
        />

      </div>
    );
  }
}

ShelfLifeUpdateView.propTypes = {
  sGrid: PropTypes.object
};

